import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import FeatureCards from 'Component/FeatureCards/FeatureCards';
import TextContent from 'Component/TextContent/TextContent';
import CtaSection from 'Component/CtaSection/CtaSection';
import MultiColumnFeature from 'Component/MultiColumnFeature/MultiColumnFeature';

import IconsData from 'IconsData/FinancialPlanning.json';
import FeatureCardsData from 'FeatureCardsData/FinancialPlanning.json';
import { FPEntail } from 'TextContentData/FinancialPlanning/FPEntail.js';
import { FPMoneyfront } from 'TextContentData/FinancialPlanning/FPMoneyfront.js';
import MultiColumnFeatureData from 'MultiColumnFeatureData/FinancialPlanning.json';

const FinancialPlanning = () => {
	return (
		<Layout>
			<SEO title="Financial Planning" description="" />
			<Hero
				heading="Financial Planning"
				iconsData={IconsData}
				breadcrumbs={[
					{
						text: 'Advisory',
						link: '#',
					},
					{
						text: 'Financial Planning',
						link: '#',
					},
				]}
				ctaFormText="Interested in Financial Planning?"
				customClass="bgFinancialPlanning"
			/>
			<FeatureCards data={FeatureCardsData} customClass="financialPlanning" />
			<TextContent
				heading="What does Financial Planning Entail?"
				data={FPEntail}
				customClass="fPEntail"
				expand="expandMobile"
			/>
			<CtaSection
				heading="Are you an HNI looking for someone to help you manage your investment portfolio? Get in touch with us today!"
				aboutText="Have you tried our smart Moneybot Advisor to assist you with financial planning & advisory?"
				aboutTextLink="Learn about MONEYBOT"
				aboutTextLinkUrl="/moneybot"
			/>
			<TextContent
				heading="Financial Planning with Moneyfront"
				data={FPMoneyfront}
				customClass="fPMoneyfront"
				linkType="button"
				linkUrl="#"
				linkText="Start goal planning"
				expand="expandMobile"
			/>
			<MultiColumnFeature
				heading="Benefits of personal financial planning"
				data={MultiColumnFeatureData}
				customClass="financialPlanning"
			/>
			<CtaSection
				heading="For investors who need in-depth personalised financial planning our advisory team is always eager to help."
				customClass="inFooter"
			/>
		</Layout>
	);
};

export default FinancialPlanning;
